import {createEntityAdapter} from '@reduxjs/toolkit';
import {Building} from '../entities';

export const buildingsAdapter = createEntityAdapter<Building>({
  selectId: (building) => building.id,
  sortComparer: (b1, b2) => b1.name.localeCompare(b2.name),
});
